import { Literal, Number as RNumber, Record, Static, Union } from "runtypes";

// Shared types for explore lump functionality
// This file exists to avoid circular dependencies between explore/types.ts and exploreLumpUtils.ts

export const ExploreLumpWindowFunctionLiteral = Union(
  Literal("row_number"),
  Literal("rank"),
  Literal("dense_rank"),
  Literal("percent_rank"),
  Literal("cume_dist"),
  Literal("ntile"),
  Literal("lag"),
  Literal("lead"),
);
export type ExploreLumpWindowFunction = Static<
  typeof ExploreLumpWindowFunctionLiteral
>;

export const ExploreLumpOrderDirectionLiteral = Union(
  Literal("asc"),
  Literal("desc"),
);
export type ExploreLumpOrderDirection = Static<
  typeof ExploreLumpOrderDirectionLiteral
>;

export const ExploreRankPredicateOpLiteral = Union(
  Literal("GT"),
  Literal("GTE"),
  Literal("EQ"),
  Literal("LTE"),
  Literal("LT"),
);
export type ExploreRankPredicateOp = Static<
  typeof ExploreRankPredicateOpLiteral
>;

export const ExploreRankPredicate = Record({
  op: ExploreRankPredicateOpLiteral,
  arg: RNumber,
});
export type ExploreRankPredicate = Static<typeof ExploreRankPredicate>;
